import Label from "componentsTemplate/Label/Label";
import { useEffect, useRef } from "react";
import { get } from "lodash";

const FormFieldFileInput = ({
  label,
  fieldName,
  formData,
  handleChange,
  classNameImagem = "",
  tipo = "",
  error = null,
}: any) => {

  const fileInputRef = useRef(null);

  const onChangeImg = (e: any) => {
    const reader = new FileReader();
    const files = e.target.files || e.dataTransfer.files;

    // if(e.target.files.length > 0){
    //   let separar = files[0].name.split('.');
    //   let aleatorio = Math.floor(Math.random() * 10000);
    //   let nome = separar[0].substr(0, 10) + aleatorio + '.' + separar[1];
    //   nome = nome.replaceAll(' ', '');
    //   const myRenamedFile = new File([files[0]], nome, {
    //     type: files[0].type
    //   });
    //   const formData = new FormData();
    //   formData.append('Files', myRenamedFile, myRenamedFile.name);
    //   handleChange(fieldName, formData);
    // }

    handleChange(fieldName, files[0]);

    reader.onload = function () {
      handleChange(`${fieldName}Preview`, reader.result);
    };

    reader.readAsDataURL(files[0]);
  };

  const onDragOver = (e: any) => {
    e.preventDefault();
  };

  const onDrop = (e: any) => {
    e.preventDefault();
    onChangeImg(e);
  };

  const urlBaseApi = process.env.REACT_APP_BACKEND_API_URL;

  const verificarSeEBase64 = (url: string) => {
    if (url == undefined) return "";
    if (url.includes("data:image") && url != undefined) {
      return url;
    } else {
      if (tipo == 1) {
        if (fieldName == "banner") {
          return urlBaseApi + "/storage/images/posts/tips/banners/" + url;
        }
      }

      if (tipo == 3) {
        if (fieldName == "logo") {
          return urlBaseApi + "/storage/images/posts/partnerships/logos/" + url;
        } else {
          return (
            urlBaseApi + "/storage/images/posts/partnerships/banners/" + url
          );
        }
      }

      if (tipo == 4) {
        if (fieldName == "logo") {
          return urlBaseApi + "/storage/images/posts/events/logos/" + url;
        } else {
          return urlBaseApi + "/storage/images/posts/events/banners/" + url;
        }
      }
    }
  };

  return (
    <div className="block md:col-span-2">
      <Label>{label}</Label>
      <div
        className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-700 border-dashed rounded-md"
        onDragOver={onDragOver}
        onDrop={onDrop}
      >
        <div className="space-y-1 text-center">
          {formData[`${fieldName}Preview`] != "" && (
            <img
              src={verificarSeEBase64(formData[`${fieldName}Preview`])}
              alt="Preview"
              className={classNameImagem}
            />
          )}

          <div className="flex flex-col sm:flex-row text-sm text-neutral-6000">
            <label
              htmlFor={`${fieldName}-upload`}
              className="relative cursor-pointer rounded-md font-medium text-primary-6000 hover:text-primary-800 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
            >
              <span>Upload de arquivo</span>
              <input
                id={`${fieldName}-upload`}
                name={`${fieldName}-upload`}
                type="file"
                className="sr-only"
                onChange={onChangeImg}
                accept="image/png, image/jpeg, image/jpg"
                ref={fileInputRef}
              />
            </label>
            <p className="pl-1">ou arraste e solte</p>
          </div>
          <p className="text-xs text-neutral-500">
            PNG, JPG, JPEG up to 2MB
          </p>
        </div>
      </div>
      {error && <span className="text-red-500 text-sm">{error}</span>}
    </div>
  );
};

export default FormFieldFileInput;
